<template>
  <div class="BusinessPartnersPage">
    <RetailNavbar style="position: fixed; top: 0; width: 100%; z-index: 5;"></RetailNavbar>
    <div class="become-partner-bg-image">
      <div class="overlay">
        <!-- Left Section -->
        <div class="left-text-section">
          <h1 class="title">Become a StockAnts Business Partner</h1>
          <p class="description">
            Join hands with us to create innovative solutions and grow together.
            Contact us to explore partnership opportunities.
          </p>
          <button class="contact-us-button" @click="goToLink('/retail-side/contact-us')">
            Contact Us
          </button>
        </div>

        <!-- Right Section -->
        <div class="right-image-section">
          <img src="../assets/images/partners-meets.png" alt="Business Partners" class="right-image" />
        </div>
      </div>
    </div>

    <!-- How It Works Section -->
    <div class="how-it-works-container">
      <div class="how-it-works">
        <h2 class="section-header">How it Works?</h2>
        <p class="section-description">
          By sharing your exclusive referral link, you can introduce your
          clientele to StockAnts Premium and Chat subscriptions and earn a
          recurring revenue.
        </p>
      </div>

      <div class="how-it-works-content">
        <div v-for="(step, index) in steps" :key="index" class="work-step">
          <img :src="step.icon" alt="Step Icon" class="step-icon" />
          <div class="step-content">
            <h3 class="step-header">{{ step.header }}</h3>
            <p class="step-description">{{ step.description }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- FAQ Section -->
    <div class="faq-quest-answer-section">
      <div class="text-center button-section" style="margin-top: 40px;">
        <span class="faq-title">FAQs</span>
      </div>

      <div class="card-container">
        <el-card class="card">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                <span class="el-collapse-item__header-text question">How do I join the StockAnts Business Partner
                  Program?</span>
              </template>
              <span class="answer" style="color: black;">
                To join, simply register as an official business partner by
                filling out the contact and bank details form. Once your
                application is approved, you’ll receive a unique referral link
                to start earning.
              </span>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <el-card class="card">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                <span class="el-collapse-item__header-text question">How much revenue do I earn on each
                  subscription?</span>
              </template>
              <span class="answer" style="color: black;">
                You will earn 30% revenue on every subscription made by retail
                users who sign up for StockAnts Premium or Chat services using
                your unique referral link.
              </span>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <el-card class="card">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                <span class="el-collapse-item__header-text question">When and how do I receive my revenue?</span>
              </template>
              <span class="answer" style="color: black;">
                Your revenue is processed and credited directly to the bank
                account you provided during registration. Payments are made on a
                predefined schedule (specific details will be shared upon
                joining).
              </span>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <el-card class="card">
          <el-collapse>
            <el-collapse-item name="1">
              <template slot="title">
                <span class="el-collapse-item__header-text question">Is there a limit on how much I can earn?</span>
              </template>
              <span class="answer" style="color: black;">
                No, there is no limit to your earnings. The more users subscribe
                using your referral link, the more revenue you generate.
                Additionally, for auto-pay subscriptions, you’ll continue
                earning recurring 30% revenue for each payment cycle.
              </span>
            </el-collapse-item>
          </el-collapse>
        </el-card>

        <button class="custom-button" @click="goToLink('/retail-side/contact-us')">
          Contact Us
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import RetailNavbar from "../components/RetailSideCompo/RetailNavbar.vue";

export default {
  name: "BusinessPartnersPage",

  components: {
    RetailNavbar,
  },
  data() {
    return {
      steps: [
        {
          header: "Sign Up",
          description:
            "As a StockAnts Business Partner, register by filling out the contact and bank details form to join as an official business partner.",
          // icon: "../assets/images/Signup.svg",
          icon: require("../assets/images/Signup.svg"),
        },
        {
          header: "Receive Your Unique Referral Link",
          description:
            "Once approved, you'll receive a unique referral link. Share this link with your clientele through social media, emails, or any other platform.",
          icon: require("../assets/images/ReferralIcon.svg"),
        },
        {
          header: "Earn Revenue on Each Subscription",
          description:
            "When a retail user subscribes to StockAnts Premium or Chat services using your referral link, you’ll receive a 30% revenue on their subscription.",
          icon: require("../assets/images/₹.svg"),
        },
        {
          header: "Recurring Revenue with Auto Pay Subscriptions",
          description:
            "Encourage your retail users to subscribe on an auto-pay basis, and you’ll earn a recurring 30% revenue for each payment cycle as long as their subscription continues.",
          icon: require("../assets/images/Recurring.svg"),
        },
      ],
    };
  },
  methods: {
    goToLink(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.BusinessPartnersPage {

  .become-partner-bg-image {
    background-image: url("../assets/images/PartnerBackroundImg.jpg");
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 100%;
    min-height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow-x: hidden;
    padding-top: 60px;

    .overlay {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;
      max-width: 1200px;
      margin: auto;

      .left-text-section {
        flex: 1;
        padding: 20px;

        .title {
          font-size: 50px;
          font-weight: 800;
          color: #fff;
          margin: 20px 0px;
        }

        .description {
          font-size: 15px;
          font-weight: 500;
          color: #fff;
          margin: 10px 0;
        }

        .contact-us-button {
          background-color: #df6052;
          border: 2px solid #df6052;
          padding: 10px 25px;
          color: white;
          font-weight: 700;
          font-size: 18px;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          margin-top: 20px;
          margin-bottom: 10px;
          // max-width: 220px;
          // text-transform: uppercase;
          box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);

          &:hover {
            background-color: #fff;
            color: #df6052;
          }
        }
      }

      .right-image-section {
        flex: 1;
        text-align: right;
        padding: 20px;

        .right-image {
          max-width: 100%;
          height: auto;
          margin-top: 20px;
          margin-bottom: 20px;
        }
      }
    }
  }

  .how-it-works-container {
    margin: 30px;
    padding: 20px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 10px 3px rgba(103, 103, 103, 0.2);
    text-align: center;
  }

  .how-it-works {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    margin: auto;
  }

  .section-header {
    font-size: 30px;
    font-weight: 800;
    color: #2d2e8d;
    margin: 10px 0px;
  }

  .section-description {
    max-width: 550px;
    font-size: 12px;
    font-weight: 500;
    color: #575757;
    // margin-bottom: 20px;
  }

  .how-it-works-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    /* Two columns */
    gap: 20px;
    // margin-top: 20px;
  }

  .work-step {
    display: flex;
    align-items: center;
    text-align: left;
    // background: #f9f9f9;
    padding: 15px;
    // border-radius: 8px;
    // box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  }

  .step-icon {
    width: 40px;
    height: 40px;
    margin-right: 15px;
  }

  .step-content {
    flex: 1;
  }

  .step-header {
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 5px;
    color: #2d2e8d;
  }

  .step-description {
    font-size: 12px;
    font-weight: 500;
    color: #575757;
  }

  .faq-quest-answer-section {
    margin-top: 40px;

    .faq-title {
      font-size: 25px;
      font-weight: bold;
      color: #2d2e8d;
      margin-bottom: 20px;
    }

    .card-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 30px;
      margin-bottom: 50px;

      .card {
        margin-bottom: 20px;
        max-width: 650px;
        width: 100%;
        border-radius: 10px;

        .question {
          font-size: 18px;
          font-weight: 600;
          color: #2d2e8d;
        }

        .answer {
          font-size: 15px;
          font-weight: 500;
          color: #575757;
        }
      }

      .custom-button {
        background-color: #df6052;
        border: 2px solid #df6052;
        padding: 10px 15px;
        color: white;
        font-weight: 700;
        font-size: 12px;
        border-radius: 50px;
        cursor: pointer;
        transition: all 0.3s ease;
        margin-top: 10px;
        margin-bottom: 30px;
        // max-width: 220px;
        text-align: center;
        white-space: nowrap !important;
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.2);
        display: inline-block;

        &:hover {
          background-color: #fff;
          color: #df6052;
          border: 2px solid #df6052;
          box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.3);
        }
      }
    }
  }

  @media (max-width: 1170px) {
    .become-partner-bg-image {
      .overlay {

        .left-text-section {
          flex: 2;

          .title {
            font-size: 40px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    .become-partner-bg-image {
      .overlay {
        flex-direction: column;
        align-items: center;

        .left-text-section {
          text-align: center;

          .title {
            font-size: 30px;
            margin: 20px auto;
          }
        }

        .right-image-section {
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .right-image {
          margin: 0 auto;
        }
      }
    }

    .how-it-works-content {
      flex-direction: column;
      align-items: center;
    }
  }

  @media (max-width: 576px) {
    .become-partner-bg-image {
      .overlay {
        .left-text-section {
          padding: 10px 20px;

          .title {
            font-size: 20px;
            margin-top: 20px;
            margin-bottom: 20px;
          }

          .description {
            font-size: 12px;
          }

          .contact-us-button {
            padding: 8px 20px;
            font-size: 12px;
            margin: 10px 0px 0px 0px;
          }
        }

        .right-image-section {
          padding: 0;

          .right-image {
            margin-top: 0px;
            max-width: 160px;
          }
        }
      }


    }

    .how-it-works-container {
      margin: 20px 10px 10px 10px;
      padding: 15px;
    }

    .how-it-works {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin: auto;
    }

    .section-header {
      font-size: 20px;
      font-weight: 800;
    }

    .section-description {
      font-size: 10px;
      font-weight: 500;
    }

    .how-it-works-content {
      grid-template-columns: 1fr;
      gap: 0px;
    }

    .work-step {
      display: flex;
      align-items: center;
      text-align: left;
      padding: 0px;
      margin-top: 20px;
    }

    .step-icon {
      width: 30px;
      height: 30px;
      margin-right: 10px;
    }

    .step-header {
      font-size: 13px;
      font-weight: 600;
    }

    .step-description {
      font-size: 10px;
      font-weight: 500;
      text-align: justify;
    }

    .faq-quest-answer-section {
      margin-top: 25px;

      .faq-title {
        font-size: 18px;
      }

      .card-container {
        margin: 10px;
        margin-bottom: 50px;

        .card {
          .question {
            font-size: 12px;
          }

          .answer {
            font-size: 10px;
          }
        }

        .custom-button {
          padding: 8px 20px;
          font-weight: 700;
          font-size: 12px;
          margin-top: 0px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.BusinessPartnersPage {
  .el-collapse-item__content {
    line-height: 1.3;
  }
}
</style>